import * as Yup from 'yup'
const userFilterSchema = Yup.object(
    {
        start_date: Yup.string()
            .nullable() // Allowing start_date to be null
            .notRequired('Start date is required'),
        end_date: Yup.string()
            .nullable() // Allowing start_date to be null
            .notRequired('Start date is required')
            .test(
                'is-greater',
                'End date cannot be earlier than the start date',
                function (value) {
                    const { start_date } = this.parent;
                    return new Date(value) >= new Date(start_date);
                }
            ),
        user_type: Yup.array()
            .notRequired()
    }
)
export default userFilterSchema